(function (window, document) {
  const property = '--product-sticky-add-height';
  const visibleClass = 'product-sticky-add-visible';

  function observe(element) {
    if (!element) return function () {};

    const root = document.documentElement;
    let disposed = false;
    let resizeObserver;
    let mutationObserver;

    function update() {
      if (disposed) return;
      const height = Math.max(
        0,
        Math.ceil(element.getBoundingClientRect().height),
      );
      root.style.setProperty(property, `${height}px`);
      root.classList.toggle(visibleClass, height > 0);
    }

    if (typeof window.ResizeObserver === 'function') {
      resizeObserver = new window.ResizeObserver(update);
      resizeObserver.observe(element);
    }
    if (typeof window.MutationObserver === 'function') {
      mutationObserver = new window.MutationObserver(update);
      mutationObserver.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style'],
      });
    }
    window.addEventListener('resize', update);
    update();

    return function cleanup() {
      if (disposed) return;
      disposed = true;
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener('resize', update);
      root.style.removeProperty(property);
      root.classList.remove(visibleClass);
    };
  }

  function start() {
    let element = document.querySelector('[data-product-sticky-add]');
    let cleanup = observe(element);
    function refresh() {
      cleanup();
      element = document.querySelector('[data-product-sticky-add]');
      cleanup = observe(element);
    }
    function clear(event) {
      const section = event?.target;
      if (
        !element ||
        (section !== element &&
          !(typeof section?.contains === 'function' && section.contains(element)))
      ) {
        return;
      }
      cleanup();
      element = null;
      cleanup = function () {};
    }
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', clear);
    return function stop() {
      cleanup();
      document.removeEventListener('shopify:section:load', refresh);
      document.removeEventListener('shopify:section:unload', clear);
    };
  }

  window.PierreParkStickyFooterClearance = { observe, start };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})(window, document);
